import React, {FC, useEffect} from 'react'
import {Modal} from 'react-bootstrap-v5'
import {useFormik} from 'formik'
import {ICandidateModel, ICandidateUpdateRequest, toCandidateForm, validationCandidate} from './CandidateModel'

type Props = {
  candidate: ICandidateModel | null
  loading: boolean
  onClose: () => void
  onSubmit: (request: ICandidateUpdateRequest) => void
}

const emptyForm: ICandidateUpdateRequest = {
  firstname: '',
  lastname: '',
  email: '',
  phone: '',
  candidateLocation: '',
  note: '',
}

export const CandidateEditModal: FC<Props> = ({candidate, loading, onClose, onSubmit}) => {
  const formik = useFormik<ICandidateUpdateRequest>({
    initialValues: emptyForm,
    validationSchema: validationCandidate,
    onSubmit,
  })

  useEffect(() => {
    if (candidate) formik.resetForm({values: toCandidateForm(candidate)})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [candidate])

  const fieldError = (field: keyof ICandidateUpdateRequest) =>
    formik.touched[field] && formik.errors[field] ? formik.errors[field] : undefined

  const renderInput = (field: keyof ICandidateUpdateRequest, label: string, required = false) => (
    <div className='col-md-6'>
      <label className={`form-label fw-bold ${required ? 'required' : ''}`}>{label}</label>
      <input
        type='text'
        className={`form-control ${fieldError(field) ? 'is-invalid' : ''}`}
        {...formik.getFieldProps(field)}
      />
      {fieldError(field) && <div className='invalid-feedback'>{fieldError(field)}</div>}
    </div>
  )

  return (
    <Modal show={!!candidate} onHide={onClose} size='lg' dialogClassName='modal-dialog-centered' backdrop='static'>
      <form onSubmit={formik.handleSubmit} noValidate>
        <div className='modal-header'>
          <h5 className='modal-title'>Adayı Düzenle</h5>
          <button type='button' className='btn-close' onClick={onClose} />
        </div>
        <div className='modal-body'>
          <div className='row g-5'>
            {renderInput('firstname', 'Ad', true)}
            {renderInput('lastname', 'Soyad', true)}
            {renderInput('email', 'E-posta')}
            {renderInput('phone', 'Telefon')}
            {renderInput('candidateLocation', 'Yaşadığı Yer')}
            <div className='col-12'>
              <label className='form-label fw-bold'>İK Notu</label>
              <textarea rows={4} maxLength={5000} className='form-control' {...formik.getFieldProps('note')} />
            </div>
          </div>
          <div className='form-text mt-4'>
            Yeni başvurular e-posta veya telefon eşleşmesiyle bu adaya bağlanır.
          </div>
        </div>
        <div className='modal-footer'>
          <button type='button' className='btn btn-light' onClick={onClose}>
            İptal
          </button>
          <button type='submit' className='btn btn-primary' disabled={loading}>
            {loading ? <span className='spinner-border spinner-border-sm' /> : 'Güncelle'}
          </button>
        </div>
      </form>
    </Modal>
  )
}
